import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { FormattedMessage, useIntl } from 'react-intl'
import { appPathname, pathname } from '../../utils/constants/pathname'
import { login } from '../../slices/auth'
import { validators } from '../../utils/helpers/validators'
import Button from '../../components/common/buttons'
import logo from '../../assets/imgs/logos/logo.svg'
import InputTextComp from '../../components/common/form-components/inputs/InputTextComp'
import PasswordComp from '../../components/common/form-components/password/PasswordComp'
import './login.scss'

const Login = () => {
  const { formatMessage: msg } = useIntl()
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const [inputs, setinputs] = useState({
    username: '',
    password: '',
  })

  useEffect(() => {}, [inputs])

  const handleChange = (event) => {
    const value = event.target.value
    const name = event.target.name
    setinputs((input) => ({ ...input, [name]: value }))
  }

  const handleSubmit = async (event) => {
    event.preventDefault()
    const resp = await dispatch(login(inputs))
    if (resp.meta.requestStatus === 'fulfilled') {
      navigate(appPathname.HOME)
    }
  }

  const validate =
    validators.hasValue(inputs?.username) &&
    validators.hasValue(inputs?.password)

  return (
    <div className="container-withBg-img">
      <div className="login">
        <form className="login-form">
          <div className="login-box">
            <img className="login-box__img" src={logo} alt="gesMoure" />
            <div className="box-form">
              <p className="title-form">
                <FormattedMessage id="auth.login" />{' '}
              </p>

              <InputTextComp
                name="username"
                value={inputs?.username}
                onChange={handleChange}
                placeholder={msg({ id: 'username' })}
              />

              <PasswordComp
                name="password"
                value={inputs?.password}
                onChange={handleChange}
              />

              <Button
                id="submitLogin"
                btnText={<FormattedMessage id="button.enter" />}
                btnType="submit"
                btnClass="btn__with-bg-type-2"
                isDisabled={!validate}
                onHandleClick={handleSubmit}
              />
              <a
                className="reset-password__link"
                href={pathname.RECOVER_PASSWORD}
              >
                <FormattedMessage id="auth.forgot-password" />{' '}
              </a>
            </div>
          </div>
        </form>
      </div>
    </div>
  )
}
export default Login
